import { Button, List, Modal } from "antd";
import React, { useState, useEffect, useMemo } from "react";
import { isEmpty } from "lodash";
import { getErrorMessage } from "src/utils/errors";
import { ILicenseChangeLogsProps } from "./interfaces";
import { getWorkerLicenseChangeLogs } from "./api";
import { getFormattedLog } from "./utils";
import { showErrorToast } from "@src/appV2/lib/Notifications";

// FIXME: Automatically disabled during ESLint config update
// eslint-disable-next-line react/function-component-definition
export const LicenseChangeLogsCard: React.FC<ILicenseChangeLogsProps> = ({ workerId }) => {
  const [initialLoading, setInitialLoading] = useState(false);
  const [changeLogs, setChangeLogs] = useState<JSX.Element[]>([]);
  const [showLogs, setShowLogs] = useState(false);
  const [loading, setLoading] = useState(false);
  const [skipCount, setSkipCount] = useState(0);
  const [totalLogsCount, setTotalLogsCount] = useState(0);

  useEffect(() => {
    if (!skipCount) {
      return;
    }
    void fetchLogs();
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [skipCount]);

  const handleShowLicenseChangeLogs = async () => {
    setChangeLogs([]);
    setInitialLoading(true);
    await fetchLogs();
    setInitialLoading(false);
    setShowLogs(true);
  };

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const { logs, totalCount } = await getWorkerLicenseChangeLogs(workerId, skipCount);
      const formattedLogs = logs.map((log) => getFormattedLog(log));
      setTotalLogsCount(totalCount);
      const data = changeLogs.concat(formattedLogs);
      setChangeLogs(data);
      setLoading(false);
    } catch (error) {
      showErrorToast("Error getting license change logs " + getErrorMessage(error));
      setLoading(false);
    }
  };

  const onLoadMore = () => {
    setLoading(true);
    setSkipCount(skipCount + 5);
  };

  const loadMore = useMemo(() => {
    return totalLogsCount > changeLogs.length ? (
      <div
        style={{
          textAlign: "center",
          marginTop: 12,
          height: 32,
          lineHeight: "32px",
        }}
      >
        <Button
          onClick={onLoadMore}
          loading={loading}
          data-testid="license-change-logs-load-more-button"
        >
          Load more
        </Button>
      </div>
    ) : null;
    // FIXME: Automatically disabled during ESLint config update
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [totalLogsCount, changeLogs, loading]);

  if (!showLogs) {
    return (
      <Button
        onClick={handleShowLicenseChangeLogs}
        loading={initialLoading}
        data-testid="license-change-logs-button"
      >
        License Change Logs
      </Button>
    );
  }

  const handleOnclose = () => {
    setShowLogs(false);
    setSkipCount(0);
    setTotalLogsCount(0);
    setChangeLogs([]);
  };

  const renderItem = (item: string) => <List.Item>{item}</List.Item>;

  return (
    <Modal
      title="License Changes"
      visible={showLogs}
      onCancel={handleOnclose}
      width={1200}
      bodyStyle={{
        maxHeight: 700,
      }}
      footer={null}
    >
      <div
        style={{
          maxHeight: 500,
          overflowY: isEmpty(changeLogs) ? "hidden" : "scroll",
        }}
      >
        <List
          size="small"
          dataSource={changeLogs as unknown as string[]}
          loadMore={loadMore}
          renderItem={renderItem}
        />
      </div>
    </Modal>
  );
};
